import Links from "./Links"
import React, { useState, useEffect } from 'react'
import { useDebounce } from "use-debounce" //we're not gonna make a req after each letter changes.. but after a period of time -- debounce

import { useResultContext } from "../contexts/ResultContextProvider"



const Searchh = () => {
    const [text, setText] = useState('Fenne Lily')
    const { setSearchTerm } = useResultContext();
    const [debouncedValue] = useDebounce(text, 300)

    useEffect(() => {
        if(debouncedValue) setSearchTerm(debouncedValue)  
    }, [debouncedValue])
    return (
        <div className="relative sm:ml-48 md:ml-72 sm:-mt-10 mt-3">
            <input 
                type="text" 
                value={text} 
                className="sm:w-96 w-80 h-10 dark:bg-gray-200 border rounded-full shadow-sm outline-none p-6 text-black hover:shadow-lg"
                placeholder="search"
                onChange={(e) => setText(e.target.value)}
            />
            {text && (
                <button type="button" className="absolute top-1.5 right-4 text-2xl text-gray-500" onClick={() => setText('')}>
                    x
                </button>
            )} 
                
            <Links />
        </div>
    )
}

export default Searchh;